export default __webpack_public_path__ + "static/media/image-ph-health-statistics-m@2x.83b50cf5.png";